// Put your applicaiton javascript here
/* Set the width of the side navigation to 250px */

function humanize(str) {
  var i, frags = str.split('_');
  for (i=0; i<frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(' ');
}


function buildHeaderPrefLocationSection() {
  let prefLocationData = getLocalStorage("prefLocation");
  if(prefLocationData) {
      var $locationDetailsContainer = $('#location-details-container');
          $locationDetailsContainer.empty();
          source = $("#LocationDetailsTemplate").html(),
          template = Handlebars.compile(source);
      //$storeDetailsContainer.append(template1(businessData));
      let prefLocation = {
          prefLocation : prefLocationData
      }
      $locationDetailsContainer.append(template(prefLocation));
  }
}

function saveLocalStorage(property, value) {
    if(window.localStorage) {
      if(typeof value === "string") {
        localStorage.setItem(property, value);
      } else {
        localStorage.setItem(property, JSON.stringify(value));
      }
    } else {
      // need to save to cookie
    }
  }
  
  function removeLocalStorage(property) {
    if(window.localStorage) {
      localStorage.removeItem(property);
    } else {
      // need to remove from cookie
    }
  }
  
  function getLocalStorage(property) {
    let value = "";
    if(window.localStorage) {
      value = localStorage.getItem(property, value);
    } else {
      // need to get from cookie
    }
    return JSON.parse(value);
  }

  function checkAnUpdateFavStar() {
    var userFav = getLocalStorage("userfav");
    if(userFav && userFav.length > 0) {
      $("#fav-star").removeClass('fal').addClass('fas');
    } else {
      $("#fav-star").removeClass('fas').addClass('fal');
    }
  }

  function openNav() {
    document.getElementById("mySidenav").style.width = "100%";
}

/* Set the width of the side navigation to 0 */
function closeNav() {
  $(".accordion.active").removeClass("active");
  $(".panel.sub:visible").hide();
  document.getElementById("mySidenav").style.width = "0";
}

// fav scripts begins
function removeFavAndReload(productData) {
  removeFav(productData);
  loadFav();
}

function removeFav(productData) {
  var userFav = getLocalStorage("userfav");
  if(userFav && userFav !== "") {
    //let obj = userFav.filter(o => o.handle !== productData.handle);
    let obj = userFav.filter(function(o) {
      return o.handle !== productData.handle;
    });
    if(obj && obj.length > 0) {
      userFav = obj;
      saveLocalStorage("userfav", JSON.stringify(userFav));
    } else {
      removeLocalStorage("userfav");
    }
  }
  }
  
  function loadFav() {
    let favProducts = getLocalStorage("userfav");
    if(!favProducts) {
      favProducts = [];
    }
    buildProducts(favProducts);
    checkAnUpdateFavStar();
  }

  function checkIfFav(productHandle) {
    var userFav = getLocalStorage("userfav");
    if(userFav && userFav !== "") {
      //let obj = userFav.filter(o => o.handle === productHandle);
      let obj = userFav.filter(function(o) {
        return o.handle === productHandle;
      });
      if(obj && obj.length != 0) {
        return true;
      }
    }
    return false;
    }
  
  function buildProducts(favProds) {
    var $productContainer = $('#products');
        
        $productContainer.empty();
        var product = {}, 
        data = {}, 
        source = $("#ProductTemplate").html(),
        template = Handlebars.compile(source);
        
    data = {
        product: favProds,
        favAvaiable: favProds.length > 0
    } 
  
    $productContainer.append(template(data));
  }

  function addFav(productData) {
    var userFav = getLocalStorage("userfav");
    if(!userFav || userFav === "") {
      userFav = [];
      userFav.push(productData);
    } else {
      //let obj = userFav.filter(o => o.id === productData.id);
      let obj = userFav.filter(function(o) {
        return o.handle === productData.handle;
      });
      if(!obj || obj.length === 0) {
        userFav.push(productData);
      }
    }
    saveLocalStorage("userfav", JSON.stringify(userFav));
    checkAnUpdateFavStar();
  }

  // fav scripts ends

$(document).ready(function(){
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
        /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
        var panel = this.nextElementSibling;
        if(panel.style.display === "block" && $(this).data('url')) {
          closeNav();
          window.location.href = $(this).data('url');
        }
        if(!$(this).hasClass('inner')) {
          $(".accordion.active").removeClass("active");
          $(".panel.sub:visible").hide();
        }
        this.classList.toggle("active");
        /* Toggle between hiding and showing the active panel */
        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
        });
    }
    
    $(document).on('mouseenter','.cart', function (event) {
        $("#location-info").hide();
        $("#mini-cart").show();
    }).on('mouseleave','#mini-cart',  function(){
        $("#mini-cart").hide();
    });
    
    $(document).on('mouseenter','.locations', function (event) {
      $("#mini-cart").hide(); 
      $("#location-info").show();
    }).on('mouseleave','#location-info',  function(){
       $("#location-info").hide();
    });

    $.fn.serializeObject = function() {
      var o = {};
      var a = this.serializeArray();
      $.each(a, function() {
        if (o[this.name]) {
          if (!o[this.name].push) {
            o[this.name] = [o[this.name]];
          }
          o[this.name].push(this.value || '');
        } else {
          o[this.name] = this.value || '';
        }
      });
      return o;
    };
});
